import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import { AnessaTranslationService } from '../../translation/anessa-translation.service';
import { UserpilotReloader } from '../../userpilot-reloader.component';

@Component({
  selector: 'can-deactivate-dialog',
  templateUrl: './can-deactivate-dialog.component.html',
  styleUrls: [
    './can-deactivate-dialog.component.scss'
  ]
})
export class CanDeactivateDialogComponent extends UserpilotReloader implements OnInit {

  title: string;
  message: string;
  html: string;
  greenButton: string;
  redButton: string;
  useGreenButton: boolean;
  useRedButton: boolean;

  constructor(public dialogRef: MatDialogRef<CanDeactivateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public translationService: AnessaTranslationService
  ) {
    super();
    this.title = data.title ? data.title : this.translationService.get('HELPER.DEACTIVATE.UNSAVED_CHANGES');
    this.message = data.message ? data.message : '';
    this.html = data.html ? data.html : null;
    this.greenButton = data.greenButton ? data.greenButton : this.translationService.get('HELPER.DEACTIVATE.STAY');
    this.redButton = data.redButton ? data.redButton : this.translationService.get('HELPER.DEACTIVATE.LEAVE');
    this.useGreenButton = data.useGreenButton === false ? false : true;
    this.useRedButton = data.useRedButton === false ? false : true;
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }


  ngOnInit() {

  }
}
